export type SessionState =
  "loading" | "authenticated" | "unauthenticated" | "expired";

export function resolveSessionState(input: {
  providerLoading: boolean;
  providerAuthenticated: boolean;
  convexAuthenticated: boolean;
  refreshFailed?: boolean;
}): SessionState {
  if (input.providerLoading) return "loading";
  if (input.refreshFailed) return "expired";
  if (!input.providerAuthenticated || !input.convexAuthenticated) {
    return "unauthenticated";
  }
  return "authenticated";
}
